import axios from '../utils/axios';

export default function addCETestimonial(adminId, data) {
    return (
        axios.post('/admin/' + adminId +'/client-engagement/testimonials/add',  data )
    )
}